export default {
  header: {
    main: "Bestellung bestätigen",
    order_summary: "Bestellübersicht",
  },
  labels: {
    total: "Gesamt",
  },
  steps: {
    payment_note: {
      title: "Zahlungs-Hinweis: Kein Bargeld",
      subtext:
        "Bei Online Bestellung bitten wir dich online zu zahlen. Die Zahlung kann jederzeit während oder nach dem Essen erfolgen. 😊 *Barzahlung nur möglich, wenn du an der Kasse bestellst.",
      button: {
        got_it: "Alles klar 👍",
      },
    },
    phone_number: {
      title: "Handynummer",
      subtext:
        "We need your phone number to send you order updates and verify you are a real person.",
    },
    personal_information: {
      title: "Für wen ist die Bestellung gedacht? 😊",
    },
  },
  buttons: {
    add_products: "+ Artikel Hinzufügen",
    place_order: "Jetzt Bestellen",
  },
  empty_order_basket: {
    title: "Los geht's",
    description: "Artikel hinzufügen, um loszulegen",
  },
  loading_overlay:
    "Bitte warte einen Moment... wir senden deine Bestellung an die Küche.",
};
